import { getRouteApi } from "@tanstack/react-router"
import { useStore } from "zustand"
import { createStore } from "zustand/vanilla"

type RosterPageUiState = {
  showExportPreview: boolean
  isExporting: boolean
  isRosterCompositionOpen: boolean

  setShowExportPreview: (value: boolean) => void
  setIsExporting: (value: boolean) => void
  setIsRosterCompositionOpen: (value: boolean) => void
  dispose: () => void
}

export const createRosterPageUiStore = () =>
  createStore<RosterPageUiState>((set) => ({
    showExportPreview: false,
    isExporting: false,
    isRosterCompositionOpen: false,

    setShowExportPreview: (value) => set({ showExportPreview: value }),
    setIsExporting: (value) => set({ isExporting: value }),
    setIsRosterCompositionOpen: (value) =>
      set({ isRosterCompositionOpen: value }),
    dispose: () => {
      set({ showExportPreview: false, isExporting: false })
    },
  }))

export type RosterPageUiStore = ReturnType<typeof createRosterPageUiStore>

export const useRosterShowExportPreview = (store: RosterPageUiStore) =>
  useStore(store, (s) => s.showExportPreview)

export const useRosterIsExporting = (store: RosterPageUiStore) =>
  useStore(store, (s) => s.isExporting)

export const useRosterIsCompositionOpen = (store: RosterPageUiStore) =>
  useStore(store, (s) => s.isRosterCompositionOpen)

export const useRosterPageStoreValue = <T>(
  store: RosterPageUiStore,
  selector: (state: RosterPageUiState) => T,
) => useStore(store, selector)

const rosterRouteApi = getRouteApi("/_authed/guild-war-roster")

export const useRosterRouteStore = () =>
  rosterRouteApi.useRouteContext({
    select: (context) => context.rosterStore,
  })
